import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedDataService } from './services/app/shared-service/shared-data.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PermissionService } from './services/app/permission-access-service/permissionBased.service';
@UntilDestroy()

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;

  constructor(
    private sharedDataService: SharedDataService,
    private permissionService: PermissionService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this)).subscribe(user => {
      if (user) {
        this.isLoggedIn = true;
        this.permissionService.setUser(user);
      } else {
        this.isLoggedIn = false;
        this.permissionService.setUser(null);
      }
    });
  }

  ngOnDestroy(): void {
  }
}
